import { useEffect, useRef, useState } from 'react';

// TODO AIFOLLOWUP
// TODO: Follow up with design on final container breakpoint values
// Also -- discuss use of enums
export enum Breakpoint {
	Small = 320,
	Large = Infinity,
}

interface UseContainerBreakpointsOptions {
	small?: number;
}

export const useContainerBreakpoints = <T extends HTMLElement = HTMLElement>(
	options: UseContainerBreakpointsOptions = {},
): {
	ref: React.RefObject<T>;
	breakpoint: Breakpoint;
	isSmall: boolean;
	isLarge: boolean;
} => {
	const { small = Breakpoint.Small } = options;
	const ref = useRef<T>(null);
	const [breakpoint, setBreakpoint] = useState<Breakpoint>(small);

	useEffect(() => {
		if (ref.current) {
			const currentRef = ref.current;

			const updateWidth = (entries: ResizeObserverEntry[]) => {
				for (const entry of entries) {
					const width = entry.contentRect.width;

					if (width <= small) {
						setBreakpoint(small);
					} else {
						setBreakpoint(Breakpoint.Large);
					}
				}
			};

			const resizeObserver = new ResizeObserver(updateWidth);
			resizeObserver.observe(currentRef);

			return () => {
				resizeObserver.unobserve(currentRef);
			};
		}
	}, [small]);

	return {
		ref,
		breakpoint,
		isSmall: breakpoint <= small,
		isLarge: breakpoint > small,
	};
};
